const type = 'SET_PCI_CARD_INFO_LOADING';

const setPCICardInfoLoading = (data) => ({
  data,
  type,
});

export default setPCICardInfoLoading;
